import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";

import {
  addProductStyleAsync,
  addProductWashTypeAsync,
  deleteProductWashTypeAsync,
  editProductStyleAsync,
  editProductWashTypeAsync,
  getProductStyleAsync,
  getProductWashTypeAsync,
} from "../../../../store/services/productInfoServices";
const WashType = () => {
  const dispatch = useDispatch();
  const {
    getProductWashTypeStatus,
    getProductWashTypeError,
    getProductWashTypeData,
    addProductWashTypeStatus,
    addProductWashTypeData,
    addProductWashTypeError,

    editProductWashTypeStatus,
    editProductWashTypeError,
    editProductWashTypeData,

    deleteProductWashTypeData,
    deleteProductWashTypeStatus,
    deleteProductWashTypeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductWashTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductWashTypeData?.length
    ? getProductWashTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedWashType, setSelectedWashType] = useState();
  const [addWashTypeMode, setAddWashTypeMode] = useState(false);
  const [addWashTypeData, setAddWashTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedWashType", selectedWashType);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductWashTypeStatus === asyncStatus.SUCCEEDED) {
      setAddWashTypeMode(false);
      setSaveDisabled(true);
      setAddWashTypeData();
    }
  }, [, addProductWashTypeStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductWashTypeAsync(selectedWashType?.wash_type_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductWashTypeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedWashType();
    }
  }, [, deleteProductWashTypeStatus]);
  useEffect(() => {
    if (editProductWashTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedWashType();
      setEditMode(false);
    }
  }, [, editProductWashTypeStatus]);
console.log("getProductWashTypeData",getProductWashTypeData,editProductWashTypeData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this WashType?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="WashType"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              WashType Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddWashTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addWashTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addWashTypeMode || !selectedWashType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddWashTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addWashTypeMode || !selectedWashType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductWashTypeStatus === asyncStatus.LOADING ||
                  editProductWashTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addWashTypeData) {
                    dispatch(addProductWashTypeAsync(addWashTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedWashType, ...editData };
                    delete a.id;
                    dispatch(editProductWashTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "wash_type_id", headerName: "ID", flex: true },
                  {
                    field: "wash_type_name",
                    headerName: "WashType Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedWashType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductWashTypeStatus === asyncStatus.IDLE ||
                  getProductWashTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addWashTypeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "WashType:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddWashTypeData({
                            ...addWashTypeData,
                            wash_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddWashTypeData({
                            ...addWashTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedWashType ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedWashType?.wash_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "WashType:",
                    comp: (
                      <InputComp
                        key={selectedWashType?.wash_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            wash_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedWashType?.wash_type_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedWashType?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedWashType?.is_active ? true : false
                        }
                        checked={selectedWashType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any wash type</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductWashTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductWashTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductWashTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductWashTypeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedWashType(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedWashType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default WashType;
